import { inject } from '@angular/core';
import { HostCommunicationService, UrlFlagsService } from '../../services';

/**
 * Initialize host communication service before authentication.
 * This ensures the message listener is set up early so the host
 * can provide authentication tokens in embedded mode.
 */
export function initializeHostCommunication() {
  const urlFlagsService = inject(UrlFlagsService);
  urlFlagsService.initialize();

  // Eagerly construct the service so its embedded() effect is registered before routing starts.
  inject(HostCommunicationService);
}
